import Theme from "@/components/Theme";
import Hero from "@/organisms/Hero";
import FeatureSectionTwocol from "@/organisms/FeatureSectionTwocol";
import WhyIntegrate from "@/organisms/WhyIntegrate";
import IntegrationOneClick from "@/organisms/IntegrationOneClick";
import Trustpilot from "@/organisms/Trustpilot";
import Faq from "@/components/organisms/FaqSection";
import Discover from "@/organisms/Discover";
import * as workiz from "@/data/integrations/workiz";
import * as servicetitan from "@/data/integrations/servicetitan";
import * as jobber from "@/data/integrations/jobber";
import * as housecallpro from "@/data/integrations/housecallpro";
import * as fieldpulse from "@/data/integrations/fieldpulse";
import * as servicefusion from "@/data/integrations/servicefusion";
import * as salesforce from "@/data/integrations/salesforce";
import * as quickbooks from "@/data/integrations/quickbooks";
import * as encircle from "@/data/integrations/encircle";
import * as zapier from "@/data/integrations/zapier";

export async function getStaticPaths() {
  const paths = [
    { params: { integrationsPages: "workiz" } },
    { params: { integrationsPages: "servicetitan" } },
    { params: { integrationsPages: "jobber" } },
    { params: { integrationsPages: "housecallpro" } },
    { params: { integrationsPages: "fieldpulse" } },
    { params: { integrationsPages: "servicefusion" } },
    { params: { integrationsPages: "salesforce" } },
    { params: { integrationsPages: "quickbooks" } },
    { params: { integrationsPages: "encircle" } },
    { params: { integrationsPages: "zapier" } },
  ];

  return {
    paths: paths,
    fallback: false,
  };
}

export async function getStaticProps({ params: { integrationsPages } }) {
  let data = {};
  const contentMap = {
    workiz,
    servicetitan,
    jobber,
    housecallpro,
    fieldpulse,
    servicefusion,
    salesforce,
    quickbooks,
    encircle,
    zapier,
  };

  if (!integrationsPages) {
    return {
      notFound: true,
    };
  }

  data.marketing = { ...contentMap[integrationsPages]["marketing"] };
  data.content = { ...contentMap[integrationsPages]["content"] };

  return {
    props: {
      data,
      pagename: integrationsPages,
    },
  };
}

export default function IntegrationsPages({ data, pagename }) {
  const seoData = data?.marketing;
  const pagedata = data?.content;

  const hero = pagedata?.hasOwnProperty("hero") && (
    <Hero
      variant="subIntegrationHero"
      heroTitle={pagedata.hero.title}
      heroContent={pagedata.hero.content}
      heroImgData={pagedata.hero.heroImgData}
    />
  );

  return (
    <Theme mainClassName="main" hero={hero} seo={seoData}>
      {pagedata?.hasOwnProperty("featureSectionTwocol") && (
        <FeatureSectionTwocol
          bgColor="white"
          isImageOnLeft={false}
          hasFlexCV={false}
          label={pagedata.featureSectionTwocol.label}
          title={pagedata.featureSectionTwocol.title}
          contentAdjToTitle={pagedata.featureSectionTwocol.contentAdjToTitle}
          subIntegrationTileData={
            pagedata.featureSectionTwocol.subIntegrationTileData
          }
        />
      )}
      {pagedata?.hasOwnProperty("whyIntegrate") && (
        <WhyIntegrate
          title={pagedata.whyIntegrate.title}
          contentData={pagedata.whyIntegrate.contentData}
          image={pagedata.whyIntegrate.image}
        />
      )}
      {pagedata?.hasOwnProperty("integrationOneClick") && (
        <IntegrationOneClick
          title={pagedata.integrationOneClick.title}
          stepsData={pagedata.integrationOneClick.stepsData}
          image={pagedata.integrationOneClick.image}
          cta={pagedata.integrationOneClick.cta}
        />
      )}
      {pagedata?.hasOwnProperty("trustPilot") && (
        <Trustpilot
          title={pagedata.trustPilot.title}
          variant={pagedata.trustPilot.variant}
          className="bc-white"
        />
      )}
      {pagedata?.hasOwnProperty("faq") && <Faq data={pagedata.faq.faqData} />}
      {pagedata?.hasOwnProperty("discover") && (
        <Discover
          bgColor={pagedata.discover.bgColor}
          title={pagedata.discover.title}
          color={pagedata.discover.color}
          cta={pagedata.discover.cta}
          href={pagedata.discover.href}
        />
      )}
    </Theme>
  );
}
